import { ReactNode, forwardRef } from 'react';

export const TableBodyWrapper = forwardRef(function TableBodyWrapper(
  {
    children,
    ...props
  }: {
    children: ReactNode;
  },
  ref: React.Ref<HTMLTableSectionElement>,
) {
  return (
    <tbody ref={ref} {...props}>
      {children}
    </tbody>
  );
});
TableBodyWrapper.displayName = 'TableBodyWrapper';
